import { Theme } from '@mui/material/styles'

const MuiFormHelperText = (theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        marginLeft: 0,
        marginTop: '0.5rem',
        color: theme.colors.caption,
        fontSize: '0.75rem',
        lineHeight: 1.5,
        marginRight: 0
      }
    }
  }
}

export default MuiFormHelperText
